// eslint-disable-next-line no-console
export const log = console.log;
export const error = console.error;
